const { getOffsetTop, prefersReducedMotion } = window.BAO.Utils

class CinematicFeature extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    window.setTimeout(() => {
      this.setAttribute('active', '')
    }, 500)
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveParallaxItems()
  }

  moveParallaxItems () {
    if (!this.offsetHeight) return

    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this) - window.innerHeight
    const elementEndPoint = getOffsetTop(this) + elementHeight

    if (this.backLayer) {
      this.moveElement(
        this.backLayer,
        window.BAO.MediaBreakpoints.isMd ? 50 : 20,
        elementStartPoint,
        elementEndPoint,
      )
    }
    if (this.titleLayer) {
      this.moveElement(
        this.titleLayer,
        window.BAO.MediaBreakpoints.isMd ? 100 : 50,
        elementStartPoint,
        elementEndPoint,
      )
    }
    if (this.frontLayer) {
      this.moveElement(
        this.frontLayer,
        window.BAO.MediaBreakpoints.isMd ? 150 : 80,
        elementStartPoint,
        elementEndPoint,
      )
    }
  }

  moveElement (el, maxDistance, elementStartPoint, elementEndPoint) {
    if (this.lastKnownY <= elementStartPoint) {
      el.style.transform = `translate3d(0px, ${maxDistance / -2}px, 0px)`

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      el.style.transform = `translate3d(0px, ${maxDistance / 2}px, 0px)`

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountY =
      maxDistance * scrollYAsAPercentageOfJourney - maxDistance / 2

    el.style.transform = `translate3d(0px, ${transformAmountY}px, 0px)`
  }

  get backLayer () {
    return this?.els?.back?.element
  }

  get titleLayer () {
    return this?.els?.title?.element
  }

  get frontLayer () {
    return this?.els?.front?.element
  }

  get isEnabled () {
    return !Shopify.designMode && !prefersReducedMotion()
  }
}

if (!customElements.get('cinematic-feature')) {
  customElements.define('cinematic-feature', CinematicFeature)
}

// moveParallaxItems () {
//     if (!this.offsetHeight) return

//     const elementHeight = this.offsetHeight

//     const elementStartPoint = getOffsetTop(this) - window.innerHeight
//     const elementEndPoint = getOffsetTop(this) + elementHeight

//     if (this.backLayer) {
//       this.moveElement(this.backLayer, 50, elementStartPoint, elementEndPoint)
//     }
//     if (this.titleLayer) {
//       this.moveElement(this.titleLayer, 100, elementStartPoint, elementEndPoint)
//     }
//     if (this.frontLayer) {
//       this.moveElement(this.frontLayer, 150, elementStartPoint, elementEndPoint)
//     }
//   }

//   moveElement (el, maxDistance, elementStartPoint, elementEndPoint) {
//     console.log(el)
//     console.log(`maxDistance: ${maxDistance}`)
//     console.log(`elementStartPoint: ${elementStartPoint}`)
//     console.log(`elementEndPoint: ${elementEndPoint}`)

//     if (this.lastKnownY <= elementStartPoint) {
//       el.style.transform = `translate3d(0px, ${maxDistance / 2}px, 0px)`

//       return
//     }

//     if (this.lastKnownY > elementEndPoint) {
//       el.style.transform = `translate3d(0px, ${maxDistance / -2}px, 0px)`

//       return
//     }

//     const totalScrollAmount = elementEndPoint - elementStartPoint

//     const scrollYAsAPercentageOfJourney =
//       1 - ((this.lastKnownY - elementStartPoint) / totalScrollAmount)

//     console.log(`scrollYAsAPercentageOfJourney: ${scrollYAsAPercentageOfJourney}`)

//     const transformAmountY =
//       maxDistance * scrollYAsAPercentageOfJourney - maxDistance / 2

//     console.log(`transformAmountY: ${transformAmountY}`)

//     el.style.transform = `translate3d(0px, ${transformAmountY}px, 0px)`
//   }
